export default "__VITE_ASSET__BBHELjc7__"